import $ from 'jquery';
import select2 from 'select2';
select2($);
import 'select2/dist/css/select2.css';

const initSelect2 = () => {
  select2(".select2", {});
};

export { initSelect2 };


document.addEventListener('turbo:load', () => {
  // Call your functions here, e.g:
  $('.select2').select2();
});